import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/services", label: "Services", testid: "nav-link-services" },
  { to: "/about", label: "About Us", testid: "nav-link-about" },
  { to: "/faq", label: "FAQ", testid: "nav-link-faq" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkClass = ({ isActive }) =>
    `text-sm tracking-wide transition-colors duration-300 hover:text-lime-300 focus:outline-none focus:ring-2 focus:ring-lime-400 rounded ${
      isActive ? "text-lime-300" : "text-zinc-400"
    }`;

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/5" data-testid="site-navbar">
      <nav className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" onClick={() => setOpen(false)}>
          <Logo />
        </Link>
        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} className={linkClass} data-testid={l.testid}>
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/about#booking"
            data-testid="nav-book-cta"
            className="rounded-full bg-lime-400 text-black text-sm font-semibold px-6 py-2.5 transition-transform duration-300 hover:-translate-y-0.5 hover:bg-lime-300 focus:outline-none focus:ring-2 focus:ring-lime-400"
          >
            Book a visit
          </Link>
        </div>
        <button
          className="md:hidden text-zinc-200 p-2 focus:outline-none focus:ring-2 focus:ring-lime-400 rounded"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-button"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      {open && (
        <div className="md:hidden bg-black/90 backdrop-blur-xl border-t border-white/5 px-6 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              onClick={() => setOpen(false)}
              className={`text-base ${location.pathname === l.to ? "text-lime-300" : "text-zinc-300"}`}
              data-testid={`mobile-${l.testid}`}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/about#booking"
            onClick={() => setOpen(false)}
            data-testid="mobile-nav-book-cta"
            className="rounded-full bg-lime-400 text-black text-sm font-semibold px-6 py-3 text-center"
          >
            Book a visit
          </Link>
        </div>
      )}
    </header>
  );
};
